import Avatar from "../Avatar";
import { BreadCrumbs } from "../BreadCrumbs";
import { Text } from "../catalyst/text";
import React from 'react'
export const PlayerDetails: React.FC<any> = ({ player, selectPlayer }) => {
  return (
    <>
      <BreadCrumbs
        pages={[
          { name: "Players", href: "", current: false },
          {
            name: `${player.title} ${player.firstName} ${player.lastName}`,
            href: "",
            current: true,
          },
        ]}
      />
      <div className="flex flex-col items-center justify-center p-4 bg-white dark:bg-gray-900 rounded-lg shadow-md">
        <Avatar
          imageUrl={player.image}
          firstName={player.firstName}
          lastName={player.lastName}
          className="h-11 w-11 rounded-full"
        />
        <Text className="mt-4 text-lg font-semibold">
          <span>
            {player.title} {player.firstName} {player.lastName}
          </span>
        </Text>
        <Text className="mt-2 text-sm text-gray-500 dark:text-gray-400">
          {player.email}
        </Text>
        <Text className="mt-2 text-sm text-gray-500 dark:text-gray-400">
          {player.phone}
        </Text>
        <Text className="mt-2 text-sm text-gray-500 dark:text-gray-400">
          {player.handicapIndex}
        </Text>
        <Text className="mt-2 text-sm text-gray-500 dark:text-gray-400">
          {player.participation}
        </Text>
        <Text className="mt-2 text-sm text-gray-500 dark:text-gray-400">
          {player.status}
        </Text>
        <button
          onClick={() => selectPlayer(player)}
          className="mt-4 px-4 py-2 text-sm font-semibold text-white bg-blue-500 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
        >
          Select Player
        </button>
      </div>
    </>
  );
};
